import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
/* todo test 两种方式选个接口调用 */
import * as httpUtil from "@/utils/httpUtil";
const interfaces = [{
  method: "post",
  name: "workweixinBinding",
  url: "/c/pc/work/weixin/auth/binding",
  desc: "企微助手授权绑定",
  config: {
    ignoreError: true
  }
}, {
  method: "post",
  name: "workweixinCancelBind",
  url: "/c/pc/work/weixin/auth/cancelBind",
  desc: "企微助手取消绑定"
}, {
  method: "post",
  name: "workweixinQueryBind",
  url: "/c/pc/work/weixin/auth/queryBind",
  desc: "查询企微绑定情况"
}, {
  method: "get",
  name: "bindWeChatCallback",
  url: "/c/pc/common/bind/bindWeChatCallback",
  desc: "微信授权绑定公众号回调接口"
}, {
  method: "post",
  name: "cancleSyncWechat",
  url: "/c/pc/common/bind/cancleSyncWechat",
  desc: "微信公众号取消同步",
  config: {
    ignoreError: true
  }
}, {
  method: "post",
  name: "syncWechatTemplates",
  url: "/c/pc/common/bind/syncWechatTemplates",
  desc: "公众号同步模板",
  config: {
    ignoreError: true
  }
}, {
  method: "post",
  name: "wechatList",
  url: "/c/pc/common/bind/wechatList",
  desc: "获取公众号详情列表"
}, {
  method: "post",
  name: "wechatUnbind",
  url: "/c/pc/common/bind/wechatUnbind",
  desc: "解绑公众号接口"
}];
function exportsRender(interfacesArr) {
  const resultExports = {};
  interfacesArr.map(item => {
    resultExports[item.name] = data => {
      return httpUtil[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}
export default exportsRender(interfaces);